if (!customElements.get('runtime-calculator')) {
  customElements.define('runtime-calculator', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const initialize = () => this.initialize();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true, signal: this.controller.signal });
      } else {
        initialize();
      }
    }

    disconnectedCallback() {
      this.controller.abort();
    }

    initialize() {
      const config = this.querySelector('[data-runtime-config]');
      this.input = this.querySelector('.rc__input');
      if (!config || !this.input) return;
      this.config = JSON.parse(config.textContent);
      this.result = this.querySelector('.rc__result');
      this.value = this.querySelector('.rc__result-value');
      this.amount = this.querySelector('.rc__result-amount');
      this.message = this.querySelector('.rc__result-text');
      const options = { signal: this.controller.signal };

      this.querySelector('.rc__form').addEventListener('submit', event => {
        event.preventDefault();
        this.calculate(true);
      }, options);
      this.input.addEventListener('input', () => {
        this.selectDevice(null);
        this.calculate(false);
      }, options);
      this.addEventListener('click', event => {
        const device = event.target.closest('.rc__device-tab');
        const scenario = event.target.closest('.rc__scenario-load');
        if (device && this.contains(device)) {
          this.input.value = device.dataset.watts;
          this.selectDevice(device);
          this.calculate(true);
        } else if (scenario && this.contains(scenario)) {
          this.input.value = scenario.dataset.load;
          this.selectDevice(null);
          this.calculate(true);
          this.result.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        }
      }, options);
      this.selectDevice(Array.from(this.querySelectorAll('.rc__device-tab')).find(button => Number(button.dataset.watts) === Number(this.input.value)));
      this.calculate(false);
    }

    selectDevice(selected) {
      this.querySelectorAll('.rc__device-tab').forEach(button => {
        button.classList.toggle('selected', button === selected);
        button.setAttribute('aria-pressed', String(button === selected));
      });
    }

    format(value, decimals) {
      return value.toLocaleString(this.config.locale || 'en', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
    }

    calculate(showEmptyError) {
      const watts = Number(this.input.value);
      const { capacity, efficiency, maxWatts, emptyText, errorZero, errorMax, detailTemplate } = this.config;
      let error = '';
      if (!Number.isFinite(watts) || watts <= 0) {
        error = this.input.value.trim() || showEmptyError ? errorZero : '';
      } else if (watts > maxWatts) {
        error = errorMax;
      }
      const valid = Number.isFinite(watts) && watts > 0 && watts <= maxWatts;
      this.amount.hidden = !valid;
      this.result.dataset.state = valid ? 'ready' : error ? 'error' : 'empty';
      this.input.setAttribute('aria-invalid', String(Boolean(error)));
      if (!valid) {
        this.value.textContent = '';
        this.message.textContent = error || emptyText;
        return;
      }
      const hours = capacity * (efficiency / 100) / watts;
      this.value.textContent = this.format(hours, 1);
      this.message.textContent = detailTemplate
        .replaceAll('{hours}', this.format(hours, 1))
        .replaceAll('{watts}', this.format(watts, Number.isInteger(watts) ? 0 : 1));
    }
  });
}
